import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments'

const USERS_QUERY = gql`
  query users {
    users {
      results {
        ...UserFragment
      }
    }
  }
  ${USER_FRAGMENT}
`

export default USERS_QUERY
